const LANDING_PATH_PREFIX = '/landing';

export function getPostAuthDestination(pathname) {
  if (
    typeof pathname !== 'string'
    || !pathname.startsWith('/')
    || pathname.startsWith('//')
    || pathname === LANDING_PATH_PREFIX
    || pathname.startsWith(`${LANDING_PATH_PREFIX}/`)
  ) {
    return '/';
  }

  return pathname;
}

